import { api } from "#/lib/api-client";
import type { DashboardResponse } from "./types";

export async function fetchDashboard(): Promise<DashboardResponse> {
  const { data } = await api.get<DashboardResponse>("/api/hr/dashboard");
  return data;
}

export async function fetchUnreadCount(): Promise<number> {
  const { data } = await api.get("/api/hr/notifications/inbox/unread-count");

  // Handle multiple backend response shapes:
  //   number directly          → 5
  //   { unreadCount: 5 }
  //   { count: 5 }
  //   { data: 5 }
  //   { data: { unreadCount: 5 } }
  if (typeof data === "number") return data;
  const body = data?.data !== undefined ? data.data : data;
  if (typeof body === "number") return body;
  return (
    body?.unreadCount ??
    body?.count ??
    body?.unread ??
    body?.total ??
    0
  );
}

export async function markNotificationRead(id: number): Promise<void> {
  await api.put(`/api/hr/notifications/inbox/${id}/read`);
}

export async function markAllNotificationsRead(): Promise<{ marked: number }> {
  const { data } = await api.put<{ marked: number }>(
    "/api/hr/notifications/inbox/mark-all-read",
  );
  return data;
}
